export default "__VITE_ASSET__DBt0dzwy__"